// GenericObjectModalConnected.tsx
import ModalGenericObject from "./ModalGenericObject";
import { useGenericObjectModalStore } from "./useGenericObjectModalStore";


export default function InfoModalGenericObject() {
  const {
    status,
    title,
    data,
    fields,
    emptyFallback,
    closeModal,
    isLoading,
  } = useGenericObjectModalStore();

  return (
    <ModalGenericObject
      open={status === "open"}
      onClose={closeModal}
      data={data}
      fields={fields}
      title={title}
      emptyFallback={emptyFallback}
      isLoading={isLoading}
    />
  );
}
